import { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import PropTypes from "prop-types";
import TableForm2s from "../../../../components/TableFormScrb";
import { formatDate } from "../../../../commons/FormatValue";
import { useNavigate } from "react-router-dom";
import ServiceRequestService from "../../../../services/servicerequest.service";
import SequenceStatusService from "../../../../services/sequencestatus.service";

export default function WorkServiceReq({ defaultData }) {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();
  const [WorkNo, setWorkNo] = useState([]);
  const [seqStatus, setSeqStatus] = useState([]);
  
  useEffect(() => {
    setJobType(defaultData.job_type)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: SequenceStatusService.getAllSequenceStatuses(),
      callback: (res) => { setSeqStatus(res) }
    });
  }, [defaultData]);

  const columns = [
    {
      name: "Tech_Rev_Date",
      label: "วันที่รับงาน",
      type: "text",
      readOnly: true
    },
    {
      name: "ModelNumber",
      label: "ประเภทงาน",
      readOnly: true,
      format: (row) => JobType.find(item => item.Id === row.Job_Type_Id)?.Job_Type_Name,
      width: "180px"
    },
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      readOnly: true,
      inputClass: "text-success",
      onClick: (row) => navigate(`/service_work/perform/${row.Seq_No}`, {
        state: { name: "ServiceReq", data: row, arrJobType: JobType }
      }),
      width: "180px"
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      readOnly: true,
      width: "250px",
      showTooltip: true
    },
    {
      name: "Job_Cus_Date",
      label: "วันที่เข้างาน",
      readOnly: true
    },
    {
      name: "Depart_St_Name",
      label: "สถานะงาน",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Seq_St_Id",
      label: "สถานะใบสั่งงาน",
      readOnly: true,
      format: (row) => seqStatus.find(item => item.Id === row.Seq_St_Id)?.Seq_St_Des,
      showTooltip: true
    },
  ];

  const searchInput = [
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.tech_name,
      disabled: true,
      size: 4
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: defaultData.team,
      disabled: true,
      size: 4
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 4,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      })
    },
    {
      name: "start",
      label: "จากวันที่เข้างาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      max: "updatedAt"
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 4,
      min: "createdAt"
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: WorkNo
      }),
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: ServiceRequestService.getFindJobSeqno(q),
          callback: (array) => {
            const newArray = array.data?.map(arr => ({
              seq_no: arr.seqJob.seqNo
            }))
            setWorkNo(newArray)
          }
        });
      }
    },
  ];

  const getDataTable = (search) => {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = getQueryString({ page: page, limit: limit, ...search })
    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: ServiceRequestService.getFindJob(q),
      callback: (res) => { initData(res.data); setAllCountData(res.allCount) }
    });
  }
  function initData(data) {
    const newArray = data?.map((items) => ({
      ...items,
      Tech_Rev_Date: formatDate(items.TechnicianReceive[0]?.tech_rev_date),
      // Job_Type_Id: items.TechnicianReceive[0]?.job_type_id,
      Job_Type_Id: items.SeqOthersJob?.Job_Type_Id ||
        items.SeqPmJob?.Seq_Pm_No ||
        items.RepairJobs?.job_type_id ||
        items.SeqInstalljob?.job_type_id,
      Seq_No: items.SeqOthersJob?.Seq_Oth_No ||
        items.SeqPmJob?.Seq_Pm_No ||
        items.RepairJobs?.seq_repair_no ||
        // items.SeqRepairJob?.Seq_Serv_No ||
        items.SeqInstalljob?.seq_install_no,
      // items.SeqInstallJob?.Seq_Inst_No,
      Cus_Code: items.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Code ||
        items?.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Code ||
        items.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_Code,
      Cus_Name: items.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Name ||
        items.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_Name ||
        items.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_Name,
      Job_Cus_Date: formatDate(items.SeqOthersJob?.InformOtherJob?.Job_Cus_Date
        || items.SeqInstalljob?.InformInstallJobs.Job_Cus_Date
      ),
      Depart_St_Name: items.DepartJob?.Depart_St_Name,
      // Seq_St_Name: items.SequneceStatus?.Seq_St_Name,
      Seq_St_Id: items.DepartJob?.Seq_St_Id,
      // tech_mas_name:
      contract_no: items.SeqOthersJob?.InformOtherJob?.Contract_No
      ,
      // contract_type: items.SeqOthersJob?.InformOtherJob?.contract_type
      // ,
      // start_contract: items.SeqOthersJob?.InformOtherJob?.contract_start_date
      // ,
      // end_contract: items.SeqOthersJob?.InformOtherJob?.contract_end_date
      // ,
      project_no: items.SeqOthersJob?.InformOtherJob?.Project_No
        || items.SeqInstalljob?.InformInstallJobs.Project_No
      ,
      cus_no: items.SeqOthersJob?.InformOtherJob?.Customer?.Cus_NumBranch ||
        items.SeqInstalljob?.InformInstallJobs?.Customer?.Cus_NumBranch ||
        items.RepairJobs?.informRepairJob?.concern_customer_items?.Cus_NumBranch,
    }));
    setTableData(newArray || [])
  }

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Body>
          <InputSearch
            inputField={searchInput}
            field={searchInput}
            searchCallback={search => search ? getDataTable(search) : setTableData([])}
          />
        </Card.Body>
      </Card>

      <Form noValidate>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              รายละเอียดงาน
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={tableData}
              columns={columns}
              isLoading={loading}
              editForm={false}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              rowCount={allCountData}
            />
          </Card.Body>
        </Card>
      </Form>
    </>
  );
}

WorkServiceReq.propTypes = {
  defaultData: PropTypes.object,
};